'use strict';

/* eslint-disable no-unused-vars */

/**
 * Collection of utility scripts related with global variables.
 */
var globalVars = {};

// Model Includes
var SelectModel = require('../model/select');

// Constants
var TYPES = {
    SELECT: 'comCustomSelects'
};

/**
 * Get a select stored in window.comCustomSelects global variable.
 * @param {string} id - select ID
 * @returns {SelectModel | null} found select or null if none is found
 */
globalVars.getSelect = function (id) {
    // Constants
    const SELECTS = window[TYPES.SELECT];

    // Variables
    var result;

    if (
        SELECTS !== null &&
        SELECTS !== undefined &&
        Array.isArray(SELECTS) &&
        SELECTS.length
    ) {
        result = SELECTS.find(function (select) {
            return select.id === id;
        });
    }

    return result;
};

/**
 * Spinner - Page level
 * Execute or stop a spinner to page body.
 * @returns {Fn} JQuery function
 */
$.comCustom = function () {
    var Fn = function () {
        /**
         * Get a select by id.
         * @param {string} id - select id
         * @returns {SelectModel | null} found select
         */
        this.getSelect = function (id) {
            return globalVars.getSelect(id);
        };

        /**
         * Get every select added to global variables.
         * @returns {Array<SelectModel>} with every select added to global variables
         */
        this.getAllSelects = function () {
            return window[TYPES.SELECT];
        };
    };

    return new Fn();
};
